import { apiClient } from "../api"
import { stringifyParams } from "../utils/api"
import { BeaconParams, DTO_BeaconPositions, DTO_MobilePositions } from "./types/positions"

export const getRealTimePositions = () => {
  const ac = apiClient()
  const promise = ac.get('/realtimeposition/')
    .then(res => res.data)
  return promise
}

export const getMobileLocations = (fleetids: number[]): Promise<DTO_MobilePositions> => {
  const ac = apiClient()
  const queryStr = stringifyParams({ fleetid: fleetids })
  const promise = ac.get(`/mobilelocation/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const getBeaconLocations = (params: BeaconParams): Promise<DTO_BeaconPositions[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`/beaconreading/latest/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}
